export default "__VITE_ASSET__CSgYHEQF__"